module.exports = function(vars) {
var __t, __p = '';
__p += '<div class="player-overlay-segment">\n	<div class="row shady-row">\n		<div class="col-md-12">\n			<h1 class="player-video-title"></h1>\n		</div>\n	</div>\n</div>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/single-video-overlay.ejs